import { Outlet } from "react-router-dom";

/**
 * Service Hub shell. The section nav (Forms Catalogue / My Requests / Approvals
 * / Delegation) used to live in a left sub-rail here; as of issue #7 it expands
 * inline under "Service Hub" in the main sidebar (see config/nav.ts), so this is
 * now just the parent route element that renders the active section.
 */
export function ServiceHubLayout() {
  return <Outlet />;
}
